import React, { Component } from 'react';

class Error extends Component {

  render() {
    return (
      <div className="ui negative message">
        <div className="header">
          Sorry, something went wrong!
        </div>
        <p>{this.props.message}</p>
      </div>
    );
  }
}

export default Error;




// WEBPACK FOOTER //
// ./src/Error.js